var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.297,
    height: 13.57,
    viewBox: "0 0 19.297 13.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-bed",
    "data-name": "Icon ionic-ios-bed",
    transform: "translate(-2.25 -8.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_47",
    "data-name": "Trac\\xE9 47",
    d: "M20.608,14.625h-.017a.941.941,0,0,0-.939.939.1.1,0,0,1-.095.095H4.24a.1.1,0,0,1-.095-.095.941.941,0,0,0-.939-.939H3.189a.941.941,0,0,0-.939.939v7.77a.941.941,0,0,0,.939.939h.017a.941.941,0,0,0,.939-.939v-.267a.173.173,0,0,1,.172-.172H19.479a.173.173,0,0,1,.172.172v.267a.941.941,0,0,0,.939.939h.017a.941.941,0,0,0,.939-.939v-7.77A.941.941,0,0,0,20.608,14.625Z",
    transform: "translate(0 -2.079)",
    fill: "#364436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_48",
    "data-name": "Trac\\xE9 48",
    d: "M5.638,10.546h.826a.147.147,0,0,0,.147-.147V9.922A.589.589,0,0,1,7.2,9.334h3.581a.589.589,0,0,1,.588.588V10.4a.147.147,0,0,0,.147.147H12.4a.147.147,0,0,0,.147-.147V9.922a.589.589,0,0,1,.588-.588h3.581a.589.589,0,0,1,.588.588V10.4a.147.147,0,0,0,.147.147h.826a.3.3,0,0,0,.294-.294V6.8A1.179,1.179,0,0,0,17.39,5.625H6.519A1.179,1.179,0,0,0,5.344,6.8v3.452A.3.3,0,0,0,5.638,10.546Z",
    transform: "translate(0.022 3)",
    fill: "#364436"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBed);
export default __webpack_public_path__ + "static/media/icon-bed.6303188dd8382a1480e3a3975edb749e.svg";
export { ForwardRef as ReactComponent };